export default __webpack_public_path__ + "static/media/Conscript's Belt of the Shining Sun.5b6c108b.jpg";